var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistoryFan = function SvgHistoryFan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3.223a11.35 11.35 0 0 1 11.226 7.947.493.493 0 0 1-.29.612L12 16.061 1.064 11.782a.494.494 0 0 1-.29-.612A11.35 11.35 0 0 1 12 3.223m3.75 16.054L12 16.061l-3.75 3.216a5.44 5.44 0 0 0 7.5 0m-2.452-8.036 2.05-7.616m.012 8.484 4.883-5.747M8.64 12.109 3.757 6.362m6.945 4.879-2.05-7.616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.95 14.124a4.94 4.94 0 0 0-4.95-3 4.94 4.94 0 0 0-4.95 3"
  })));
};
export default SvgHistoryFan;